const dlFontShadowed = '#b7c4d0';
const dlErrorColor = '#ff6065';
const dlBoxShadow = '#e9e9e9';
const dlStandardBorderRadius = '6px';
const dlSelectedOptionBackgroundColor = '#E5F2FF';
const dlFocusedOptionBackgroundColor = '#D1E8FF';
const dlComponentBoxFont = '#555555';
const dlBoxShadowWidth = '0.2rem';
const dlFontSizeNormal = '14px';

const isFocused = {
  borderColor: '#80bdff',
  outline: 0,
  boxShadow: `0 0 0 ${dlBoxShadowWidth} rgba(0,123,255,.25)`,
};

const hasError = {
  borderColor: dlErrorColor,
};

const hasShadowedBorder = {
  borderColor: dlBoxShadow,
  borderRadius: dlStandardBorderRadius,
  borderSpacing: '0',
  borderCollapse: 'separate',
  boxShadow: 'none',
};

export const reactSelectContainer = (provided) => ({
  ...provided,
  cursor: 'pointer',
});

export const reactSelectControl = (provided, state) => ({
  ...provided,
  ...(state.selectProps.dlHasShadowedBorder ? hasShadowedBorder : {}),
  ...(state.isFocused ? isFocused : {}),
  ...(state.selectProps.dlHasError ? hasError : {}),
});

export const reactSelectOption = (provided, state) => ({
  ...provided,
  cursor: 'pointer',
  fontSize: dlFontSizeNormal,
  ...(state.isSelected
    ? {
        backgroundColor: dlSelectedOptionBackgroundColor,
        color: dlComponentBoxFont,
      }
    : {}),
  ...(state.isFocused ? {backgroundColor: dlFocusedOptionBackgroundColor} : {}),
});

export const reactSelectPlaceholderShadowed = (provided) => ({
  ...provided,
  color: dlFontShadowed,
});

export const reactSelectInput = (provided) => ({
  ...provided,
  fontSize: dlFontSizeNormal,
});

export const reactSelectMenu = (provided) => ({
  ...provided,
  marginTop: dlBoxShadowWidth,
});

export const reactSelectMultiValue = (provided) => ({
  ...provided,
  fontSize: dlFontSizeNormal,
});

export const reactSelectMultiValueLabel = (provided) => ({
  ...provided,
  fontSize: dlFontSizeNormal,
  padding: '0px 3px 0px 3px',
});

export const reactSelectMultiValueRemove = (provided) => ({
  ...provided,
  '&:hover': {
    backgroundColor: 'initial',
    color: 'initial',
  },
});

export const dlReactSelect = {
  container: reactSelectContainer,
  control: reactSelectControl,
  input: reactSelectInput,
  menu: reactSelectMenu,
  multiValue: reactSelectMultiValue,
  multiValueLabel: reactSelectMultiValueLabel,
  multiValueRemove: reactSelectMultiValueRemove,
  option: reactSelectOption,
  placeholder: reactSelectPlaceholderShadowed,
};
